import { IDataLayerFilter } from '@models/IDataLayerFilter';
import { IListingFilter } from '@models/IListingFilter';
import { IStoredFilters } from '@models/IStoredFilters';
import convertValuesToArrays from './convertValuesToArrays';

const mapToDataLayerFilters = (
  filters: IListingFilter[],
  facets: Record<string, string | string[]>
) => {
  // If submitting directly after loading the page, the facets do not come in as arrays, so need to turn them into one
  const validFacets = convertValuesToArrays(facets) as IStoredFilters;

  return Object.keys(validFacets).reduce<IDataLayerFilter[]>(
    (dataLayerFiltersAcc, categoryKey) => {
      const categoryDataLayerFilters =
        validFacets[categoryKey]?.reduce<IDataLayerFilter[]>(
          (categoryDataLayerFiltersAcc, categoryFacetKey) => {
            const currentCategory = filters.find(
              (filter) => filter.key === categoryKey
            );

            const currentCategoryFacetLabel = currentCategory?.values.find(
              (value) => value.key === categoryFacetKey
            )?.label;

            const filter = {
              filter_category: currentCategory?.label,
              filter_name: currentCategoryFacetLabel,
            };

            if (filter.filter_category && filter.filter_name) {
              return [...categoryDataLayerFiltersAcc, filter];
            }
            return categoryDataLayerFiltersAcc;
          },
          []
        ) ?? [];

      return [...dataLayerFiltersAcc, ...categoryDataLayerFilters];
    },
    []
  );
};

export default mapToDataLayerFilters;
